export const isVersionOutdated = (installedVersion, latestVersion) => {
  if (!installedVersion || !latestVersion) return false

  const installedParts = String(installedVersion).split('.').map(Number)
  const latestParts = String(latestVersion).split('.').map(Number)
  const length = Math.max(installedParts.length, latestParts.length)

  for (let i = 0; i < length; i += 1) {
    const installed = installedParts[i] || 0
    const latest = latestParts[i] || 0
    if (installed < latest) return true
    if (installed > latest) return false
  }

  return false
}
